import Vue from 'vue'

export const theme = Vue.observable({
    mode: localStorage.getItem('theme') || 'light',
})

export const setTheme = (mode) => {
    theme.mode = mode
    localStorage.setItem('theme', mode)

    // Mettre à jour les classes sur le body
    document.body.classList.remove('light', 'dark', 'theme--light', 'theme--dark')
    document.body.classList.add(mode)

    // Émettre un événement personnalisé
    window.dispatchEvent(new CustomEvent('theme-changed', { detail: { mode } }))
}

document.body.classList.add(theme.mode)
